export default __webpack_public_path__ + "static/media/bg6.1ce914a4.jpg";